enum OrderDocumentEntryPoints {
  getStatistic = '/api/statistic/order-document/list',
  getStatisticDownload = '/api/statistic/order-document/download',
  getStatisticTotals = '/api/statistic/order-document/totals',
}

export default OrderDocumentEntryPoints;
